
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore, collection, getDocs, addDoc, doc, updateDoc } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
    apiKey: "AIzaSyC34_w2to_P2vKkSjsHF12qGYrUouN8H9o",
    authDomain: "eyecare-council.firebaseapp.com",
    projectId: "eyecare-council",
    storageBucket: "eyecare-council.firebasestorage.app",
    messagingSenderId: "78563812280",
    appId: "1:78563812280:web:44bc45067702e764cda54d"
  };
  

const app = initializeApp(firebaseConfig);

const db = getFirestore(app);  // Firestore initialization
const storage = getStorage(app);  // Firebase Storage initialization

export const auth = getAuth(app);
export { db, storage, getDocs, collection, addDoc, doc, updateDoc  };  // Correct export


